import * as React from "react";
import { styled, SxProps, Box, Stack, Typography, Card, CardActionArea, Chip } from "@mui/material";

import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";

import ConfigContentRecaps, {
  ConfigContentRecapsProps,
} from "../../Config/ConfigContentRecaps/config-content-row-recap";
import OrderStatusIcon from "../../Misc/Status/OrderStatus/order-status";
import TitleCard from "../TitleCard";
import { OrderProductType } from "../../../Core/Api/Types/order-product-type";
import OrderProductIcon from "../../Misc/OrderProductIcon/order-product-icon";
import { OrderStatus as OrderStatusEnum } from "../../../Core/Api/Types/order-status";

export type OrderHorizontalCardProps = {
  className?: string;
  sx?: SxProps;
  title: string;
  titleId: number;
  subtitle: string;
  thumbnail: string;
  status: OrderStatusEnum;
  config: {
    title: string;
    configType: OrderProductType;
    price: string;
    content: ConfigContentRecapsProps;
    attachement?: string;
  };
  onClickConfigDetails?: any;
};

const OrderHorizontalCard: React.FC<OrderHorizontalCardProps> = (props) => {
  const { config, title, titleId, subtitle, thumbnail, status, onClickConfigDetails } = props;

  return (
    <Wrapper variant="outlined" onClick={onClickConfigDetails}>
      <CardActionArea component="div">
        <Stack spacing={1} direction="row" alignItems="center">
          <OrderProductIcon type={config.configType} color="info" fontSize="small" />
          <Typography variant="subtitle2" fontWeight={600}>
            {config.title}
          </Typography>
        </Stack>
        <Box mt={0.5}>
          <ConfigContentRecaps color="text.tier" {...config.content} />
        </Box>
        <Stack direction="row" justifyContent="space-between" mt={1.5} mb={2}>
          <OrderStatusIcon status={status} />
          <Chip label="2" color="info" icon={<ChatOutlinedIcon />} />
        </Stack>
        <TitleCard poster={thumbnail} title={title} titleId={titleId} subtitle={subtitle} price={config.price} />
      </CardActionArea>
    </Wrapper>
  );
};

const Wrapper = styled(Card)(({ theme }) => ({
  borderRadius: 8,
  backgroundImage: "none",
  boxShadow: "none",
  transition: "background .3s",
  "&:hover": {
    borderColor: theme.palette.backgroundAlpha.borderFocus,
    background: theme.palette.backgroundAlpha.hover,
  },
  ".MuiCardActionArea-root": {
    padding: theme.spacing(2),

    // "&:hover .MuiCardActionArea-focusHighlight": {
    //   backgroundColor: theme.palette.backgroundAlpha.hover,
    //   opacity: 1,
    // },
  },
  ".MuiCardActionArea-focusHighlight": {
    opacity: 1,
    backgroundColor: "transparent",
    transition: "background .3s",
  },
}));

export default OrderHorizontalCard;
